import React, { useRef } from "react";
import Asterisk from "../../utils/Asterisk";
import { useFormCtx } from "../../../context/formContext/formContext";
import { toast } from "react-toastify";

const LegalInput = ({
  htmlFor,
  label,
  required,
  type,
  name,
  relative,
  top,
  inputColor,
  value,
}) => {
  const { fillCoporateInfo } = useFormCtx();
  const toastShownRef = useRef(false); // 👈 prevent repeated toasts

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Real-time validation
    if (
      (name === "legalName" || name === "tradeName") &&
      inputValue.length > 100
    ) {
      if (!toastShownRef.current) {
        toast.error(
          "Too long! Max 100 characters."
        );
        toastShownRef.current = true;
      }
      return; 
    }

    toastShownRef.current = false; 
    fillCoporateInfo(e);
  };

  return (
    <div className={`form-group ${relative} ${top} w-full md:w-1/2`}>
      <div className="flex flex-col">
        <label htmlFor={htmlFor} className="flex items-center">
          <span
            className={`font-bold ${inputColor ? "text-white" : "text-black"}`}
          >
            {label}
          </span>
          <span>
            <Asterisk required={required} />
          </span>
        </label>
        <input
          type={type}
          name={name}
          value={value || ""}
          className={`border border-black w-full outline-none rounded-xl py-3 px-4 font-bold text-black`}
          onChange={handleChange}
          required={required}
          placeholder={`Enter ${label.toLowerCase()}`}
        />
      </div>
    </div>
  );
};

export default LegalInput;
